import React from 'react';
import PropTypes from 'prop-types';

import { LONG_STRING_MAX_LENGTH, isRequired, isUrl, maxLength } from 'utils/validators';
import { getOrganizationDisplayName } from 'utils/view';
import { t } from 'utils/language';

import { Form, FormField } from 'components/form';
import Input from 'components/inputs/input/Input';

const BrandBusinessDetailsSettingsForm = ({
  currentOrganization,
  onSubmit,
  onTextInput,
  canEdit,
  children,
  values,
  organizationType,
  organizationSettings
}) => (
  <Form
    key={canEdit}
    onSubmit={onSubmit}
  >
    <FormField
      label={t(`signup_${organizationType}_name`)}
      fontSize="small"
      showValidationIcon={false}
      showRequiredMark
    >
      <Input
        type="text"
        value={organizationType === 'agency' ? organizationSettings?.name : getOrganizationDisplayName(currentOrganization)}
        disabled
        data={{ qa: 'brand-business-details__input-name' }}
      />
    </FormField>

    <FormField
      label={t('signup_website')}
      fontSize="small"
      showRequiredMark
      validators={[
        isRequired(values.website),
        isUrl(values.website)
      ]}
    >
      <Input
        type="text"
        name="website"
        value={values.website}
        disabled={!canEdit}
        placeholder={canEdit ? t('website_placeholder') : ''}
        onChange={(e) => onTextInput(e, 'businessDetails')}
        data={{ qa: 'brand-business-details__input-web' }}
      />
    </FormField>

    <FormField
      label={t('signup_vat_number')}
      fontSize="small"
      showRequiredMark
      validators={[
        isRequired(values.taxId),
        maxLength(values.taxId, LONG_STRING_MAX_LENGTH)
      ]}
    >
      <Input
        type="text"
        name="taxId"
        value={values.taxId}
        disabled={!canEdit}
        onChange={(e) => onTextInput(e, 'businessDetails', true)}
        data={{ qa: 'brand-business-details__input-tax' }}
      />
    </FormField>

    {children}
  </Form>
);

BrandBusinessDetailsSettingsForm.propTypes = {
  children: PropTypes.any,
  organizationType: PropTypes.string,
  organizationSettings: PropTypes.object,
  currentOrganization: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onTextInput: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired
};

export default BrandBusinessDetailsSettingsForm;
